// Keep the interview route from inheriting a previous page's scroll position.
// Reset only when the interview UI changes phase: entering the warm-up gate or
// moving from the warm-up into the real interview. Ordinary question-to-question
// updates keep their current scroll behavior.

const INTERVIEW_PATH = /^\/interview\/[^/]+\/?$/;
let lastPhase = null;

function currentPhase(root) {
  if (!INTERVIEW_PATH.test(window.location.pathname)) return null;
  if (root.querySelector('[data-testid="warmup-gate"]')) return "warmup";
  if (root.querySelector('[data-testid="interview-container"]')) return "interview";
  return null;
}

function syncInterviewScroll(root) {
  if (!INTERVIEW_PATH.test(window.location.pathname)) {
    lastPhase = null;
    return;
  }

  const phase = currentPhase(root);
  if (!phase || phase === lastPhase) return;

  lastPhase = phase;
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
}

if (typeof window !== "undefined" && typeof document !== "undefined") {
  const root = document.getElementById("root");
  if (root) {
    const observer = new MutationObserver(() => syncInterviewScroll(root));
    observer.observe(root, { childList: true, subtree: true });
    syncInterviewScroll(root);
  }
}
